const getSetCookie = {
  getCookie: cname => {
    const name = `${cname}=`;
    if (typeof window !== 'undefined') {
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieSplit = decodedCookie.split(';');
      for (let index = 0; index < cookieSplit.length; index += 1) {
        let cookie = cookieSplit[index];
        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length);
        }
      }
    }
    return '';
  },
  setCookie: (cname, cvalue, days, minutes) => {
    const date = new Date();
    date.setTime(date.getTime() + (days ? days * 24 * 60 : 1 + minutes) * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    let domain = 'domain=';
    if (typeof window !== 'undefined') {
      if (window.location.hostname.indexOf('lenskart.com') > -1) {
        domain += '.lenskart.com';
      } else {
        domain += window.location.hostname;
      }
      document.cookie = `${cname}=${cvalue};${expires};${domain};path=/`;
    }
  },
  deleteCookie: cname => {
    let domain = 'domain=';
    if (window.location.hostname.indexOf('lenskart.com') > -1) {
      domain += '.lenskart.com';
    } else {
      domain += window.location.hostname;
    }
    document.cookie = `${cname}=;expires=${new Date(new Date().getTime()).toUTCString()};${domain};path=/`;
  },
  setCookieWithDomain: (cName, value, extime) => {
    const dt = new Date();
    dt.setTime(dt.getTime() + extime);
    let domain = 'domain=';
    if (window.location.hostname.indexOf('lenskart.com') > -1) {
      domain += '.lenskart.com';
    } else {
      domain += window.location.hostname;
    }
    const cValue = `${escape(value) + ((extime === null) ? '' : `;${domain};expires=${dt.toGMTString()}`)}; path=/`;
    document.cookie = `${cName}=${cValue}`;
  },
  setCookieWithOptions: (cName, value, options) => {
    let domain = 'domain=';
    if (window.location.hostname.indexOf('lenskart.com') > -1) {
      domain += '.lenskart.com';
    } else {
      domain += window.location.hostname;
    }
    const cValue = `${escape(value)};${domain};expires=${options.expires};path=${options.path};secure=${options.secure};`;
    document.cookie = `${cName}=${cValue}`;
  }
};
export default getSetCookie;
